export enum ProgrammeReference {
    DIAGNOSTIC = 'Assessment::V2::AssessmentProgramme',
    GCSE = 'Gcse::V1::GcseProgramme',
    SATS = 'Sats::V2::SatsProgramme',
    TEACHER_SELECTION = 'TeacherSelection::V1::TeacherSelectionProgramme',
}

export interface ProgrammeBody {
    user_id?: number;
    programme_type_id?: number;
    programme_type_reference?: string;
    start_date?: string;
    end_date?: string;
    classroom_type?: string;

    // additional properties
    onboarding_completed?: boolean;
}

export interface StudentProgramme {
    id: number;
    name: string;
    user_id: number;
    programme_type_reference: ProgrammeReference;
    key_stage?: number;
    subject_directories: SubjectDirectory[];
    onboarding_completed?: boolean;
    intro_lo_completed: boolean;
}

export interface SubjectDirectory {
    id: number;
    subject_id: number;
    subject_title: string;
    learning_session_id: number;
    diagnosed_phase: string;
    subject_status: string;
    position: number;
    added_by_id: number;
    added_at: string;
    completed_by_id: number;
    completed_at: string;
    skipped_by_id: number;
    skipped_at: string;
    undiagnosed_by_id: number;
    undiagnosed_at: string;
    started: boolean;
}
